import { render, staticRenderFns } from "./tableItemprint.vue?vue&type=template&id=36a4dfbd"
import script from "./tableItemprint.vue?vue&type=script&lang=js"
export * from "./tableItemprint.vue?vue&type=script&lang=js"
import style0 from "./tableItemprint.vue?vue&type=style&index=0&id=36a4dfbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports